import React from 'react';
import { BillingData, PaymentMethod } from '../BillingTypes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useModal } from 'components/modals/ModalContext';
import PaymentMethodForm from './PaymentMethodForm';

interface PaymentMethodCardProps {
    loading: string;
    billingData: BillingData,
    paymentMethodData: PaymentMethod;
    refetchPaymentMethod: () => void;
};

const PaymentMethodCard: React.FC<PaymentMethodCardProps> = ({ 
    loading, billingData, paymentMethodData, refetchPaymentMethod 
}) => {
    const { t } = useTranslation();
    const { initializeModal } = useModal();

    // Get the payment method display
    const getPaymentMethodDisplay = (paymentMethodData: PaymentMethod) => {
        // If no payment method is added, show nothing
        if (!paymentMethodData) {
            return '-'
        }
    
        // Configure the display for cards
        if (paymentMethodData.payment_type === 'card') {
            return (
                <div>
                    <p>{t('billing.general.creditcard_label')}</p>
                    <p>**** {paymentMethodData.card_last_digits} ({paymentMethodData.card_exp_month}/{paymentMethodData.card_exp_year})</p>
                </div>
            );
        }
        
        // Configure the display for sepa
        if (paymentMethodData.payment_type === 'sepa_debit') {
            return (
                <div>
                    <p>{t('billing.general.sepa_debit_label')}</p>
                    <p>**** {paymentMethodData.sepa_iban_last4}</p>
                </div>
            );
        }
        
        return '-';
    };


    const handleAddPaymentMethod = () => {
        initializeModal(
            <PaymentMethodForm billingData={billingData} />, { 
                title: t('billing.general.add_payment_method'),
                modalSize: 'small-medium', 
                onSuccess: () => refetchPaymentMethod(),
            }
        )
    }

    return (
        <div className='card payment-method'
             onClick={() => handleAddPaymentMethod()}>
            <div className='card-edit-header'>
                <h6>{t('billing.general.payment_method_header')}</h6>
                <span className='edit-icon'>
                    <FontAwesomeIcon
                        icon={faPen} 
                        onClick={() => handleAddPaymentMethod()}
                    />
                </span>
            </div>
            {loading === 'show-loader' ? (
                <div className="loader"></div>
            ) : loading === 'success' && (
                getPaymentMethodDisplay(paymentMethodData)
            )}
        </div>
    )
}

export default PaymentMethodCard;